import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Template2Pages/components/Header2';
import Footer from './Template2Pages/components/Footer2';

const Template2 = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            <Header cartCount={3} wishlistCount={5} />

            <main className="w-full">
                {/* Profile Section - Mobile-optimized */}
                <section className="w-full bg-gray-50 py-8 lg:py-16 px-3 sm:px-4 lg:px-12">
                    <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-16">
                        <div className="relative flex-shrink-0">
                            <img
                                src="https://placehold.co/200x200/E0E0E0/333333?text=Profile"
                                className="w-32 h-32 lg:w-48 lg:h-48 object-cover rounded-full border-4 border-white shadow-xl ring-4 ring-gray-100/50 active:scale-95 lg:hover:scale-105 transition-all duration-300"
                                alt="Designer Profile"
                            />
                        </div>
                        <div className="flex-1 text-center lg:text-left">
                            <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6 leading-tight">Designer's Name</h1>
                            <p className="text-base lg:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                                A modern collection of contemporary designs, blending minimalist aesthetics with bold, unique touches.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Category Carousel - Horizontal Scroll */}
                <section className="w-full py-8 lg:py-16 px-3 sm:px-4 lg:px-12">
                    <h2 className="text-2xl lg:text-4xl font-bold text-center mb-8 lg:mb-12 text-gray-900">
                        Shop by Category
                    </h2>

                    {/* Horizontal Scroll Container */}
                    <div className="flex overflow-x-auto space-x-4 lg:space-x-6 pb-4 scrollbar-hide snap-x snap-mandatory -mx-3 px-3 sm:-mx-4 sm:px-4 lg:mx-0 lg:px-0">
                        {[
                            { name: "Indianwear", img: "https://placehold.co/400x500/E0E0E0/333333?text=Indianwear" },
                            { name: "Westernwear", img: "https://placehold.co/400x500/D0D0D0/333333?text=Westernwear" },
                            { name: "Blazers", img: "https://placehold.co/400x500/C0C0C0/333333?text=Blazers" },
                            { name: "Kurtis", img: "https://placehold.co/400x500/B0B0B0/333333?text=Kurtis" },
                            { name: "Accessories", img: "https://placehold.co/400x500/A0A0A0/333333?text=Accessories" }
                        ].map((cat) => (
                            <div key={cat.name} className="group relative overflow-hidden rounded-2xl shadow-lg active:scale-95 lg:hover:shadow-2xl lg:hover:scale-105 transition-all duration-500 w-60 lg:w-72 flex-shrink-0 snap-center">
                                <div className="aspect-[4/5] relative">
                                    <img src={cat.img} alt={cat.name} className="absolute inset-0 w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                                    <div className="absolute inset-0 flex flex-col justify-end p-4 lg:p-6">
                                        <h3 className="text-white text-xl lg:text-2xl font-bold mb-1">{cat.name}</h3>
                                        <p className="text-white/90 text-sm lg:text-base">15 products</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Product Grid - Mobile-first */}
                <section className="w-full bg-gray-50 py-12 lg:py-24 px-3 sm:px-4 lg:px-12">
                    <div className="flex justify-between items-baseline mb-8 lg:mb-12">
                        <h2 className="text-3xl lg:text-5xl font-bold text-gray-900">All Products</h2>
                        <span className="text-xs lg:text-sm text-gray-600">12 items</span>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-2 lg:gap-6">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(id => (
                            <div key={id} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-200 active:scale-95 lg:hover:shadow-2xl lg:hover:-translate-y-1 lg:hover:border-gray-900 transition-all duration-200 group">
                                <div className="aspect-[3/4] overflow-hidden relative bg-gray-50">
                                    <img
                                        src={`https://placehold.co/400x500/F0F0F0/333333?text=Product+${id}`}
                                        alt={`Product ${id}`}
                                        className="object-cover object-center w-full h-full group-hover:scale-110 transition-transform duration-700"
                                    />
                                </div>
                                <div className="p-3 lg:p-4 space-y-2">
                                    <h3 className="text-sm lg:text-base font-semibold text-gray-900 line-clamp-1">Product Title {id}</h3>
                                    <p className="text-base lg:text-lg font-bold text-gray-900">${(69 + id * 10)}.00</p>
                                    <button
                                        onClick={() => navigate('/template2/cart')}
                                        className="w-full bg-gray-900 text-white py-2 px-4 rounded-lg font-semibold text-xs lg:text-sm active:bg-gray-800 lg:hover:bg-gray-800 transition-all duration-200"
                                    >
                                        Add to Cart
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Template2;
